import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const AsteriskIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props
  return (
    <SvgIcon viewBox="0 -960 960 960" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M410-120v-238L204-239l-70-121 206-120-206-119 70-121 206 119v-239h140v239l206-119 70 121-206 119 206 120-70 121-206-119v238H410Z" />
    </SvgIcon>
  )
}
export default AsteriskIcon
